// config.js

const bizIcon = "https://cataleyacleaningservicesllc.com/wp-content/uploads/2024/10/catalleya-logo-cleaning_Mesa-de-trabajo-1-1536x674.png";
const imageOne = "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YmF0aHJvb218ZW58MHx8MHx8fDA%3D";
const imageTwo = "https://cataleyacleaningservicesllc.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-02-at-12.30.21-PM-1.jpeg";
const imageThree = "https://cataleyacleaningservicesllc.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-02-at-12.30.20-PM-5.jpeg";
const imageFour = "https://cataleyacleaningservicesllc.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-02-at-12.30.24-PM.jpeg";
const imageFive = "https://cataleyacleaningservicesllc.com/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-02-at-12.30.20-PM-2.jpeg";

const socialMediaLink = 'https://cataleyacleaningservicesllc.com/';

export const siteConfig = {
  title: "Cataleya Cleaning Services LLC",
  metaDescription: "Cataleya Cleaning Services LLC",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-blue-500"
  },
  logo: {
    src: bizIcon,
    alt: "Cataleya Cleaning Services LLC",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Cataleya Cleaning Services LLC",
    headline: "Your Trusted Cleaning Services in Kansas",
    address: "Dr Mission, KS 66202",
    description: "Whether you need daily, weekly, or monthly cleaning, we work around your schedule to keep your home or business spotless without disrupting your routine. With years of experience, Cataleya Cleaning Services LLC is dedicated to providing reliable, high-quality cleaning tailored to meet each client's unique needs.",
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Cleaning Services in Kansas",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      name: 'Experienced Professionals',
      description: 'Our cleaning team is highly skilled and committed to excellence, consistently going above and beyond to meet your expectations with every visit.',
    },
    {
      name: 'Customized Cleaning Plans',
      description: 'We recognize that every space has unique needs, so we offer tailored cleaning plans to match your schedule and preferences perfectly.',
    },
    {
      name: 'Eco-Friendly Approach',
      description: 'Dedicated to both your well-being and the environment, we use eco-friendly, non-toxic cleaning products that are safe for you and your family.',
    },
  ],
  services: {
    sectionTitle: "Services Offered",
    description: "Whether you need residential or commercial cleaning, we provide a seamless, hassle-free experience. Let us handle the cleaning, so you can focus on what matters most!",
    callouts: [
      {
        name: 'Regular Cleaning',
        description: 'Our regular cleaning service keeps your space fresh and tidy with routine visits that fit your schedule.',
        imageSrc: imageTwo,
        imageAlt: 'Clean, organized residential living space',
      },
      {
        name: 'Carpet Cleaning',
        description: 'We deep clean carpets to remove dirt, stains, and allergens, leaving them fresh and revitalized for long-lasting quality.',
        imageSrc: imageThree,
        imageAlt: 'Professional carpet cleaning in a residential setting',
      },
      {
        name: 'Office Cleaning',
        description: 'Keep your workspace clean and welcoming with our office cleaning services, ensuring a healthy environment for employees and visitors.',
        imageSrc: imageFour,
        imageAlt: 'Spotless office environment with organized workstations',
      }
    ],
  },
  about: {
    sectionTitle: "About Us",
    description: "Dedicated to Excellence in Cleaning. At Cataleya Cleaning Services LLC, we pride ourselves on delivering exceptional cleaning services tailored to your specific needs. Whether you’re a homeowner seeking regular cleanings or a business in need of commercial services, we bring over 10 years of experience to ensure high-quality results that leave your space sparkling.",
    image: {
      src: imageFive,
      alt: "Lisa Moccia, real estate agent",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Dr Mission, KS 66202, USA",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.5007270918293!2d-94.63204248459265!3d39.01540877955686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87c0ef8c4f27ad27%3A0x8b33f77ad03d1196!2sMission%2C%20KS%2066202%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { name: 'Apple Maps', url: 'https://maps.apple.com/?address=Dr%20Mission,%20KS%2066202&ll=39.0154,-94.6320&q=Mission%20KS' },
      { name: 'Bing Maps', url: 'https://www.bing.com/maps?q=Mission,+KS+66202&FORM=HDRSC6' },
      { name: 'Google Earth', url: 'https://earth.google.com/web/search/Dr+Mission,+KS+66202,+USA/@39.0154,-94.6320,15a,814.57589625d,35y,0h,0t,0r' },
      { name: 'Google Maps', url: 'https://goo.gl/maps/k3M3VGme4FzUtPqq7' }
    ]
  },
  contact: {
    sectionTitle: "Ready for a Spotless Space?",
    description: "Contact Cataleya Cleaning Services LLC to discuss your cleaning needs or to schedule a service. Whether you need regular home cleaning, deep cleaning, or commercial services, our team is here to provide top-quality results every time.",
    socialLinks: {
      facebook: socialMediaLink,     
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      linkedin: socialMediaLink,
      youtube: socialMediaLink
    },
    contactNumbers: [
      "Office: (913) 212-5800"
    ],
    logo: bizIcon,
    emailRecipient: "cataleyacleaningservicesllc@gmail.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
